import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../../Reusable/Footer";
import NavigationBar from "../../Reusable/NavigationBar";
import ScrollToTop from "../../Reusable/ScrollToTop";
import Banner from "./Banner";
import ProjectDetails from "./ProjectDetails";

const SogoVR = () => {
    const { pathname } = useLocation();

	useEffect(() => {
		document.title = "SogoVR Case Study";
		window.scrollTo(0, 0);

		return () => {
			document.title = "Oluwatobi Fabusuyi";
		};
	}, [pathname]);

	return (
		<div className="homepage sogo-vr">
			<NavigationBar />
			<Banner />
            <ProjectDetails />
			<Footer />
			<ScrollToTop />
		</div>
	);
};

export default SogoVR;
